import { percentageFilter, suffixFilter } from "app/filters/ngFilters";
import type { FC } from "react";
import styled from "styled-components";
import type { ITableCellProps } from "../interfaces/ITableCellProps";

const StyledBounceRate = styled.div`
    text-align: right;
`;

export const BounceRate: FC<Pick<ITableCellProps, "value">> = ({ value }) => {
    return (
        <StyledBounceRate>
            <span className="value">{suffixFilter()(percentageFilter()(value, 2, "-"), "%")}</span>
        </StyledBounceRate>
    );
};
BounceRate.displayName = "BounceRate";
